import _ from 'lodash';

module.exports = function (angular, config) {
    return function ($scope, $state, engine,gamelog,data) {
        const node = engine.getCurrentNode();
        $scope.texts = data.texts;
        console.log("current node");

        $scope.showDestinations = false;

        _displayNode(node);
        if (node.gameover) {
            $state.go('main.end');
        }

        $scope.travelTo = (city) => {
            $state.go(engine.travelTo(city.id).gameover?'main.end':'main.city', null, { reload: true });
        }

        $scope.investigateTo = (place) => {
            place.show = true;
            place.dialog = _.sample(place.dialogs);
            if(place.clue)gamelog.add(place.clue);
            const result = engine.investigate();
            $scope.timePool = result.timePool;
            $scope.showDestinations = true;
            if(result.gameover){
                $state.go('main.end');
            }
        };

        function _displayNode(node) {
            $scope.city = node.city;
            $scope.places = _.chain(node.city.places).cloneDeep().map((o, key) => {
                o.id = key;
                return o;
            }).value();
            console.log(node);
            $scope.destinations = node.choices;
            $scope.timePool = node.timePool;
            $scope.history = gamelog.getHistory();
            console.log(node.city.places);
            console.log($scope.places);
        }
    };

};